export const handleLettersOnly = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/

    if (!regex.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab' && e.key !== 'Delete') {
        e.preventDefault()
    }
}

export const toInt = (value: any): number => {
  const n = parseInt(value, 10);
  return isNaN(n) ? 0 : n;
};

export const capitalLetter = (text: string): string => {
  return text.charAt(0).toUpperCase() + text.slice(1);
};